import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { onSuccess, useApiMutation } from "../utils/api";
import { Link } from "react-router-dom";
import { useAppContext } from "../contexts/AppContext";
import { SimpleForm } from "../utils/simple_form";

const AddCategoryModal = ({
  board,
  close,
  refetch,
}: {
  board: { uuid: string };
  close: () => void;
  refetch: () => void;
}) => {
  const { post } = useApiMutation();

  const handleAddboard = ({ name }) => {
    post(`/api/user/add_category/${board.id}`, { name }).then(
      onSuccess(() => {
        refetch();
        close();
      })
    );
  };

  return (
    <Modal show={true} onHide={close}>
      <Modal.Header closeButton>
        <Modal.Title>Add Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <SimpleForm
          fields={{ name: { required: true, label: "Category" } }}
          onSubmit={handleAddboard}
        />
      </Modal.Body>
    </Modal>
  );
};

export const Sidebar = ({
  board,
  refetch,
}: {
  board: {
    id: string;
    name: string;
    top: { uuid: string; name: string };
    family: { uuid: string; name: string }[];
  };
  refetch: () => void;
}) => {
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const { searchTerm, setSearchTerm, voteFilter, setVoteFilter } = useAppContext();

  const family = board.family;

  const voteFilters = [
    { type: "like", icon: "far fa-grin" },
    { type: "meh", icon: "far fa-meh" },
    { type: "dislike", icon: "far fa-frown" },
    { type: "approve", icon: "fas fa-check" },
  ];

  return (
    <div className="p-4">
      <div className="d-flex align-items-center hover-show-parent">
        <Link to={`/boards/${board.top.id}`} className="mb-0 me-2 h4 no-underline black">
          {board.top.name}
        </Link>
      </div>
      <div className="mt-2">
        {family.map((board) => (
          <Link
            key={board.id}
            to={`/boards/${board.id}`}
            className={`py-2 cursor-pointer d-block black no-underline ${
              board.id === board.id ? "bg-light fw-bold" : ""
            }`}
          >
            {board.name}
          </Link>
        ))}
        <button
          className="btn-text fs-14 gray mt-3"
          onClick={() => setAddCategoryModal(true)}
        >
          + Add Category
        </button>
      </div>

      <div className="fs-20 fw-500 mt-15 d-flex align-items-center justify-content-between">
        <span>Filters</span>
        {(searchTerm || voteFilter) && (
          <button
            className="btn-text fs-12 gray-8"
            onClick={() => {
              setSearchTerm("");
              setVoteFilter(null);
            }}
          >
            clear
          </button>
        )}
      </div>
      <input
        type="text"
        className="form-control w-100 mt-3"
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="mt-3">
        <div className="d-flex gap-2">
          {voteFilters.map(({ type, icon }) => (
            <button
              key={type}
              className={`btn btn-sm px-2 py-1 ${
                voteFilter === type ? "btn-primary" : "btn-light"
              }`}
              onClick={() => setVoteFilter(voteFilter === type ? null : type)}
            >
              <i className={icon} />
            </button>
          ))}
        </div>
      </div>

      {addCategoryModal && (
        <AddCategoryModal
          board={board.top}
          close={() => setAddCategoryModal(false)}
          refetch={refetch}
        />
      )}
    </div>
  );
};
